import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '9';
const IABid = [104];

export const createPixel = (): HTMLImageElement => {
  const script = document.createElement('script');
  script.src = '//sync.go.sonobi.com/uc.js';
  document.body.appendChild(script);

  const img = document.createElement('img');
  img.style.display = 'none';
  img.src = `https://purch-sync.go.sonobi.com/us?${getUserSyncURL(ID, false)}[UID]`;

  return img;
};

export default once(({ userSyncPixelsManager, fastdom, env, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    if (env.gdprUser) {
      return;
    }

    const img = createPixel();
    fastdom.mutate(function userSyncSonobiAddElement() {
      document.body.appendChild(img);
    });
  }),
);
